import { DataIndex } from 'rc-table/lib/interface';

// Filter

export type LogicType = 'and' | 'or';

// eslint-disable-next-line no-shadow
export enum LogicTypes {
  and = 'and',
  or = 'or',
}

export type FilterOperator = 'contains' | 'notcontains' | 'startWith' | 'eq' | 'neq' | 'lt' | 'lte' | 'gt' | 'gte';

// eslint-disable-next-line no-shadow
export enum FilterOperators {
  contains = 'contains',
  notcontains = 'notcontains',
  startWith = 'startWith',
  eq = 'eq',
  neq = 'neq',
  lt = 'lt',
  lte = 'lte',
  gt = 'gt',
  gte = 'gte',
}

export interface Filter {
  field: string;
  ignoreCase?: boolean;
  operator: FilterOperator;
  value: number | boolean | string;
}

export interface GridFilter {
  logic: LogicType;
  filters: Filter[];
}

// Sort

export type SortDirection = 'asc' | 'desc';

// eslint-disable-next-line no-shadow
export enum SortDirections {
  asc = 'asc',
  desc = 'desc',
}

export interface Sort {
  field: DataIndex;
  dir: SortDirection;
  dateFormat?: string;
}

export type GridSort = Sort[];

// Pagination

export interface GridPagination {
  skip: number;
  pageSize: number;
}
